import { MenuItem } from './menu.model';
import { ApiserviceService } from 'src/app/core/services/apiservice.service';

export const MENU:MenuItem[] =[
 
    {
        id: 1,
        label: 'ANA MENU',
        isTitle: true
    },
  
    {
        id: 2,
        label: 'Anasayfa',
        link: '',
        icon:'bx-home'
    },
    {
        id: 3,
        label: 'Ürünler',
        link: '/urunler',
        icon:'bx-store'
    },
    {
        id: 4,
        label: 'Kullanıcı Bilgisi',
        link: '/kullanici',
        icon:'bx-user'
    },
    {
        id: 5,
        label: 'Ayarlar',
        link: '/ayarlar',
        icon:'bx-edit'
    },

];
